import { Component, Input, OnChanges } from '@angular/core';
import { ICommsTemplateAttachment } from '../../../interfaces/comms-template/comms-template-attachment';
import { FormControl, FormGroup } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { CommsTemplateService } from '../../../services';
import { SelectItem } from 'primeng';

@Component({
  selector: 'app-comms-attachments',
  templateUrl: './comms-attachments.component.html',
  styleUrls: ['./comms-attachments.component.scss'],
})
export class CommsAttachmentsComponent implements OnChanges {
  isLoaded = false;
  commsAttachments: ICommsTemplateAttachment[] = [];
  selectedAttachment: ICommsTemplateAttachment = null;
  createEditForm: FormGroup;
  isEditMode = false;
  showForm: boolean;
  contentTypes: SelectItem[] = [
    { label: '', value: null },
    { label: 'PDF', value: 'application/pdf' },
    { label: 'JPEG', value: 'image/jpeg' },
    { label: 'PNG', value: 'image/png' },
  ];

  @Input() templateId: number;

  constructor(
    private commsTemplateService: CommsTemplateService,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnChanges(): void {
    this.initForm();
    this.loadAttachments();
  }

  initForm(): void {
    this.createEditForm = new FormGroup({
      id: new FormControl(),
      attachmentUrlTemplate: new FormControl(),
      attachmentFilenameTemplate: new FormControl(),
      attachmentContentType: new FormControl(),
      commsTemplateId: new FormControl(this.templateId),
    });
  }

  loadAttachments(): void {
    this.isLoaded = false;

    this.commsTemplateService.getTemplateAttachments(this.templateId).then((attachments) => {
      this.commsAttachments = attachments;
      this.showForm = false;
      this.selectedAttachment = null;
      this.isLoaded = true;
    });
  }

  createAttachment(): void {
    this.showForm = true;
    this.isEditMode = false;
    this.initForm();
  }

  deleteAttachment(): void {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this attachment?',
      header: 'Confirmation',
      icon: 'pi pi-question',
      accept: () => {
        this.deleteConfirmed();
      },
    });
  }

  deleteConfirmed(): void {
    this.commsTemplateService.deleteTemplateAttachment(this.selectedAttachment.id).then((x) => {
      this.selectedAttachment = null;
      this.loadAttachments();
    });
  }

  editAttachment(item): void {
    this.showForm = true;
    this.selectedAttachment = item;
    this.isEditMode = true;
    this.createEditForm.patchValue(item);
  }

  save(): void {
    if (this.createEditForm.get('id').value > 0) {
      this.commsTemplateService.updateTemplateAttachment(this.createEditForm.value).then((x) => {
        this.selectedAttachment = null;
        this.loadAttachments();
      });
    } else {
      this.commsTemplateService.createTemplateAttachment(this.createEditForm.value).then((x) => {
        this.loadAttachments();
      });
    }
  }
}
